import * as React from 'react'
import { FC, useMemo } from 'react'
import { EXTERNAL_ENTITY_TYPE } from '@sales-center/common'
import { useGetExternalEntityUrl } from '@user/store/authorization/hooks/useGetExternalEntityUrl'
import { getStyles } from './styling'
import Link from '@mui/material/Link'
import { useTheme } from '@mui/material/styles'

interface Props {
  externalEntityId: string
  externalEntityType: EXTERNAL_ENTITY_TYPE
}

function getLabel(externalEntityType: EXTERNAL_ENTITY_TYPE): string {
  switch (externalEntityType) {
    case EXTERNAL_ENTITY_TYPE.ServiceOrders: {
      return 'Service Order'
    }
    case EXTERNAL_ENTITY_TYPE.ServiceSetups: {
      return 'Service Setup'
    }
    case EXTERNAL_ENTITY_TYPE.Programs: {
      return 'Program'
    }
  }
}

export const ExternalEntityServiceLink: FC<Props> = (props) => {
  const { externalEntityId, externalEntityType } = props

  const url = useGetExternalEntityUrl(externalEntityId, externalEntityType)

  const label = useMemo(
    () => getLabel(externalEntityType),
    [externalEntityType],
  )
  const styles = getStyles(useTheme())
  return (
    <Link
      sx={styles.link}
      href={url}
      target="_blank"
      data-test-id={`external-entity-service-link-${externalEntityId}`}
    >
      {label} <img src="/static-assets/icons/arrow-northeast.svg" />
    </Link>
  )
}
